import _ from 'lodash';

/* @ngInject */
export default function CertificationFactory($sce, $http, HPConfig) {
    const certificationPages = [
        {
            pageName: 'courses',
            pageDisplayName: 'Suggested Courses',
            isEnabled: true
        },
        {
            pageName: 'guides',
            pageDisplayName: 'Quick Reference Guides',
            isEnabled: true
        }
    ];

    const certificationGuideColumns = [
        {
            name: 'title',
            displayName: 'Title',
            isEnabled: true
        },
        {
            name: 'courseNo',
            displayName: 'Course #',
            isEnabled: true
        }
    ];

    const certificationGuides = [
        {
            english: {
                name: 'Certification Requirements',
                courseNo: 'HU100',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/WT100_Certification%20Requirements.pdf'),
            }
        },
        {
            english: {
                name: 'How It Works',
                courseNo: 'HU100',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/WT100_How%20It%20Works.pdf'),
            },
            spanish: {
                name: 'How It Works (Spanish)',
                courseNo: 'HU100',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/WT100_How%20It%20Works%20Spanish.pdf'),
            }
        },
        {
            english: {
                name: 'Application - In Review Reasons',
                courseNo: 'HU101',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP102_Application%20In%20Review%20Reasons.pdf'),
            },
            spanish: {
                name: 'Application - In Review Reasons (Spanish)',
                courseNo: 'HU101',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HP102_Application%20In%20Review%20Reasons%20Spanish.pdf'),
            }
        },
        {
            english: {
                name: 'HERO Program Eligibility',
                courseNo: 'HU101',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HP102_HERO%20Program%20Eligibility.pdf'),
            },
            spanish: {
                name: 'HERO Program Eligibility (Spanish)',
                courseNo: 'HU101',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HP102_HERO%20Program%20Eligibility%20Spanish.pdf'),
            }
        },
        {
            english: {
                name: 'Calling In Products',
                courseNo: 'HU101',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP103_Calling%20In%20Products.pdf'),
            }
        },
        {
            english: {
                name: 'Eligible Products',
                courseNo: 'HU101',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('https://9662473e561b2ca15fec-e991096dabe6d2069d3f005000c6b73d.ssl.cf2.rackcdn.com/HEROEligibleProductsList.pdf'),
            }
        },
        {
            english: {
                name: 'Financing Document Set Guide',
                courseNo: 'HU102',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP104_Financing Document Set Guide.pdf'),
            }
        },
        {
            english: {
                name: 'eSign Financing Documents',
                courseNo: 'HU102',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP104_eSign%20Financing%20Documents.pdf'),
            }
        },
        {
            english: {
                name: 'eSign Project Completion',
                courseNo: 'HU103',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP105_eSign%20Project%20Completion.pdf'),
            }
        },
        {
            english: {
                name: 'Project Funding Checklist',
                courseNo: 'HU103',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('https://e46c35b14ba172b610db-5bdc7e6ccbce2b667854e87f83bdb832.ssl.cf1.rackcdn.com/Project_Funding_Checklist.pdf'),
            }
        },
        {
            english: {
                name: 'Making Payments',
                courseNo: 'HU103',
                action: '8/15/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP106_Making%20Payments.pdf'),
            }
        },
        {
            english: {
                name: 'Proposal Plus - Solar Tax Credit Pay Down',
                courseNo: 'HU101',
                action: '10/7/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/Proposal%20Tool%20-%20Solar%20Tax%20Credit%20Pay%20Down.pdf'),
            }
        },
        {
            english: {
                name: 'Change Order Request - FAQ',
                courseNo: 'HU102',
                action: '10/31/2014',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HP104.5_Change%20Order%20Process_FAQ.pdf'),
            }
        },
        {
            english: {
                name: 'Funding Document Submission Guide',
                courseNo: 'HU103',
                action: '2/25/2015',
                url: $sce.trustAsResourceUrl('http://d9d9087c54be8c649af5-c39597e5c7b01ac033a978dbfa710d50.r92.cf1.rackcdn.com/HERO-Contractor-Funding-Document-Submission.pdf'),
            }
        },
        {
            english: {
                name: 'HERO Confirmation Call Checklist',
                courseNo: 'HU101',
                action: '2/25/2015',
                url: $sce.trustAsResourceUrl('https://e6cd8b4b39dd042fc477-c39597e5c7b01ac033a978dbfa710d50.ssl.cf1.rackcdn.com/HERO%20Confirmation%20Call%20Checklist.pdf'),
            }
        }
    ];

    return {
        getCertificationPages,
        getCertificationGuideColumns,
        getCertificationGuides,
        getUserCertificate,
        getUserCourses,
        getCourseUrl
    };

    function getCertificationPages() {
        return _.filter(certificationPages, page => page.isEnabled === true);
    }

    function getCertificationGuideColumns() {
        return _.filter(certificationGuideColumns, column => column.isEnabled === true);
    }

    function getUserCertificate() {
        return `${HPConfig.heroProApi}ELearning/UserCertificate`;
    }

    function getCertificationGuides() {
        return certificationGuides;
    }

    function getUserCourses() {
        return $http.get(`${HPConfig.heroProApi}ELearning/UserCourses`, { cache: true });
    }

    function getCourseUrl(courseId) {
        return $http.get(`${HPConfig.heroProApi}ELearning/CourseUrl?courseId=${courseId}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/certification/certificationFactory.js